import { DAY_BEFORE, HALF_HOUR_BEFORE, HOUR_BEFORE, SAME_TIME, WEEK_BEFORE } from 'task-forms-lib/constants/RelativeDates';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import once from 'transmute/once';
import { View } from 'foundations-components/components/View';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { updateDefaultReminderPresetSetting } from '../../reducers/stagedSettingsReducer';
import { defaultReminderPresetSelector } from '../../selectors/SettingsSelectors';
import { trackReminderPresetSettingChanged } from '../../usage/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
const NO_REMINDER = null;
const reminderPresets = [SAME_TIME, HALF_HOUR_BEFORE, HOUR_BEFORE, DAY_BEFORE, WEEK_BEFORE];
const getNoReminderOption = once(() => ({
  value: NO_REMINDER,
  text: I18n.text(`CrmSettingsTaskReminders.defaults.reminderPresets.noReminder`)
}));
const getReminderOptions = once(() => [getNoReminderOption(), ...reminderPresets.map(preset => ({
  value: preset,
  text: I18n.text(`CrmSettingsTaskReminders.defaults.reminderPresets.${preset}`)
}))]);
export default function ReminderSettings() {
  const dispatch = useDispatch();
  const reminderPreset = useSelector(defaultReminderPresetSelector);
  const handleReminderPresetChange = useCallback(evt => {
    dispatch(updateDefaultReminderPresetSetting(evt.target.value));
    trackReminderPresetSettingChanged(evt.target.value);
  }, [dispatch]);
  return /*#__PURE__*/_jsx(View, {
    inlineSize: "300px",
    children: /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CrmSettingsTaskReminders.defaults.reminder"
      }),
      children: /*#__PURE__*/_jsx(Select, {
        "data-test-id": "CrmSettingsTaskReminders.defaults.reminder.select",
        searchable: false
        // @ts-expect-error UISelect TS types do not allow 'null' as an option value, but 'NO_REMINDER' is null. uicomponents v3.67.0 may have broken this? see https://git.hubteam.com/HubSpot/UIComponents/pull/11341
        ,
        options: getReminderOptions(),
        value: reminderPreset,
        defaultValue: NO_REMINDER,
        placeholder: getNoReminderOption().text,
        onChange: handleReminderPresetChange
      })
    })
  });
}